/**
 * DXP onboarding terms PDF URL (staging vs production CDN).
 */
export function getDxpOnboardingTermsPdfUrl(): string {
  const environment =
    window?.partnerRegistrationConfig?.REACT_APP_DYNAMIC_FORM_ENVIRONMENT;
  const isProd = environment === "prod";
  return isProd
    ? "https://d38k06t7m3x001.cloudfront.net/public-shared/DXP-onboarding-terms-and-conditions.pdf"
    : "https://d35xh3uitfhmg4.cloudfront.net/public-shared/DXP-onboarding-terms-and-conditions.pdf";
}
